import { useTranslation } from 'react-i18next';

import { AddIcon, DraftsIcon } from '@treams/treams-icons';
import { Button, CardList, Jumbo, Separator } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import NoteCard from './NoteCard';

export default function PeerSharedNotes(props: { userID: string }) {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const userID = viewer.id;

	const query = graphql.useMutualNotesQuery({
		// Not sure if the last 10 notes are actually used since the query doesn't have a limit when resolved
		variables: { id: props.userID, last: 10, filters: { showArchived: true } },
	});

	return (
		<>
			<Jumbo
				title={t('peer.notes.shared.title')}
				description={t('peer.notes.shared.description')}
				button={<Button icon={<AddIcon />} title={t('peer.notes.index.new')} link="/notes/new" />}
				footer={<Separator />}
			/>

			<CardList
				translationName="peer.notes.shared"
				query={query}
				path="user.mutualNotes"
				icon={<DraftsIcon />}
				renderCard={(item: graphql.Note) => (
					<NoteCard linkPrefix={`/users/${props.userID}`} userID={userID} note={item} />
				)}
				renderSkeleton={() => <NoteCard.Skeleton />}
			/>
		</>
	);
}
